"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _APRadio = _interopRequireDefault(require("../../../../common/APRadio/APRadio"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var BuySellAmountRow = function BuySellAmountRow(props) {
  var baseClasses = props.baseClasses,
    onClick = props.onClick,
    isActive = props.isActive,
    amountRadio = props.amountRadio,
    value1 = props.value1,
    value2 = props.value2,
    isBuySide = props.isBuySide,
    invertArrows = props.invertArrows;
  var arrow = /*#__PURE__*/_react["default"].createElement("p", {
    className: baseClasses('arrow')
  }, isBuySide && !invertArrows || !isBuySide && invertArrows ? '→' : '←');
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('amount-row', isActive && 'active'),
    onClick: onClick
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('first-in-row')
  }, /*#__PURE__*/_react["default"].createElement(_APRadio["default"], {
    name: "amountRadio",
    id: amountRadio,
    value: amountRadio
  })), /*#__PURE__*/_react["default"].createElement("div", null, value1 ? value1 : '-'), arrow, /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('last-in-row')
  }, value2 ? value2 : '-'));
};
BuySellAmountRow.propTypes = {
  baseClasses: _propTypes["default"].func.isRequired,
  onClick: _propTypes["default"].func.isRequired,
  isActive: _propTypes["default"].bool,
  amountRadio: _propTypes["default"].string.isRequired,
  value1: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  value2: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  isBuySide: _propTypes["default"].bool.isRequired
};
BuySellAmountRow.defaultProps = {
  isActive: false
};
var _default = exports["default"] = BuySellAmountRow;